"use strict";

angular.module('app.controllers.rooms', []).//
// Controller for mainview

config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('rooms', {
        abstract: true,
        parent: 'site',
        template: '<ui-view/>',
        url: '/rooms',
        controller:'RoomsOverviewHeadCTRL',
        resolve: {
            parentMenuEntryId: function () {
                'ngInject';

                return '00000000-0000-0000-0000-000000000003';
            },
            MenuEntries: function (__MenuEntry, conf_guidEmpty) {
                'ngInject';

                return __MenuEntry.$getRooms({
                    'WithDetails': true,
                    'RecursiveLevel': 4
                }).$then(function () {
                    for (var i = 0; i < this.length; i++) {
                        this[i].DeviceId = conf_guidEmpty;
                    }
                }).$asPromise();
            }
        },
        infoGuide : {
            state: 'rooms'
        },

    });
}]).controller('RoomsOverviewHeadCTRL',['$scope','f_Interval',function($scope,f_Interval){
        $scope.$on("$destroy", function () {
            f_Interval.unregisterIntervalByAppId( 'interval.roomOverview' );
        });

    }])
    .config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('rooms.default', {

        url: '/',
        parent: 'rooms',
        templateUrl: 'views/rooms_default.html',
        controller: 'RoomOverviewCtrl',
        breadcrumb: {
            initialState: true,
            name: 'NAV_Rooms'
        },
        infoGuide : {
            state: 'rooms'
        },
    });
}])
    .config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('rooms.sort', {
        parent: 'rooms',
        url: '/sort',
        templateUrl: 'views/rooms_sort.html',
        controller: 'RoomOverviewSortCtrl',
        infoGuide : {
            state: 'rooms'
        },
    });
}])
    .controller("RoomOverviewSortCtrl", ['$scope', 'MenuEntries', 'parentMenuEntryId', '$filter', '$state', 'viewMenuBarService', '__MenuEntry','$q', function ($scope, MenuEntries, parentMenuEntryId, $filter, $state, viewMenuBarService, __MenuEntry,$q) {


        $scope.init = function () {
        $scope.buttons = {
            sortMode: {
                'sortButtonGreen': true,
                'sortButton': function () {

                    $state.go('rooms.default',{},{reload:true});
                }

            }
        }
        viewMenuBarService.setButtons($scope.buttons.sortMode);
        // $scope.Rooms = MenuEntries.$encode();
        $scope.MenuEntries = MenuEntries;
        $scope.generateList();
        $scope.DragListener = {
            accept: function (sourceItemHandleScope, destSortableScope) {

                return true
            },//override to determine drag is allowed or not. default is true.
            itemMoved: function (event) {
                var item = event.source.itemScope.MenuEntry;
                // Set RestmodItem
                var RMItem = $filter('filter')($scope.MenuEntries, {MenuEntryId: item.MenuEntryId})[0];
                if (event.dest.index === 0) {
                    // Sorting at Position 0
                    RMItem.Sort = item.Sort = 0;
                } else {
                    var prevItem = event.dest.sortableScope.modelValue[event.dest.index - 1];
                    // Use Position from previous Element with inc.
                    RMItem.Sort = item.Sort = prevItem.Sort + 1;

                }
                RMItem.ParentMenuEntryId = event.dest.sortableScope.$parent.MenuEntry.MenuEntryId;
                RMItem.$save().$then(function () {
                    $scope.generateList();
                }, function () {
                    // Put back
                });


            },
            orderChanged: function (event) {
                // Moving rooms inside or Geschoss inside
                var item = event.source.itemScope.MenuEntry;

                // Set RestmodItem
                var RMItem = $filter('filter')($scope.MenuEntries, {MenuEntryId: item.MenuEntryId})[0];
                var oldSort = item.Sort;
                if (event.dest.index === 0) {
                    // Sorting at Position 0
                    RMItem.Sort = item.Sort = 0;
                } else if (event.dest.index > 0) {
                    var prevItem = event.dest.sortableScope.modelValue[event.dest.index - 1];
                    // Use Position from previous Element with inc.
                    RMItem.Sort = item.Sort = parseInt(prevItem.Sort) + 1;
                }
                RMItem.$save().$then(function () {
                    $scope.generateList();
                }, function () {
                    // Put back
                });
            }
        }
    }
    $scope.generateList = function () {
        $scope.MenuEntries = __MenuEntry.$getRooms({
            'WithDetails': true,
            'RecursiveLevel': 4
        }).$then(function () {
            for (var i = 0; i < this.length; i++) {
                this[i].DeviceId = conf_guidEmpty;
            }
        }).$finally(function () {


            var Levels = $filter('orderBy')($filter('filter')($scope.MenuEntries, {'ParentMenuEntryId': parentMenuEntryId}), '+Sort');
            $scope.Rooms = [];
            var smallEntry = function (e) {
                var o = {
                    "_type": e._type,
                    "DisplayName": e.DisplayName,
                    "Sort": e.Sort,
                    "MenuEntryId": e.MenuEntryId,
                    "ParentMenuEntryId": e.ParentMenuEntryId,
                    "DeviceId": e.DeviceId,
                    "Children": []

                };
                return o;
            };
            for (var i = 0; i < Levels.length; i++) {
                var o = smallEntry(Levels[i]);
                var Children = $filter('orderBy')($filter('filter')($scope.MenuEntries, {'ParentMenuEntryId': Levels[i].MenuEntryId}), '+Sort');

                for (var j = 0; j < Children.length; j++) {
                    o.Children.push(smallEntry(Children[j]));
                }
                $scope.Rooms.push(o);

            }
        })
    }

    $scope.saveOrder = function (MenuEntry, Parent) {


        var vlist = $filter('orderBy')($scope.Rooms, '+Sort');
        var parent = parentMenuEntryId; // 00...0003
        var found = false;
        for (var i = 0; i < vlist.length; ++i) {

            if (MenuEntry.MenuEntryId === vlist[i].MenuEntryId) {
                MenuEntry.Sort = i > 0 ? ( vlist[i - 1].Sort + 1) : 0;
                MenuEntry.ParentMenuEntryId = parent;
                found = true;
               // alert('Parent Top');
                break;
            }
            if (!found) {
                parent = vlist[i].MenuEntryId;
                var children = $filter('orderBy')($scope.Rooms[i].Children, '+Sort');
                for (var j = 0; j < children.length; j++) {
                    if (children[j].MenuEntryId === MenuEntry.MenuEntryId) {
                        MenuEntry.Sort = j > 0 ? ( children[j - 1].Sort + 1) : 0;
                        MenuEntry.ParentMenuEntryId = parent;
                        found = true;
                       //alert('Parent' + vlist[i].DisplayName);
                        break;
                    }
                }
            }
            if (found == true) break;

        }



        /*__MenuEntry.$buildRaw(MenuEntry).$save().$then(function () {
         $scope.MenuEntries = __MenuEntry.$getRooms({
         'WithDetails': true,
         'RecursiveLevel': 4
         }).$then(function () {
         for (var i = 0; i < this.length; i++) {
         this[i].DeviceId = conf_guidEmpty;
         }
         $scope.generateList();
         });

         }, function () {

         });*/

    }
    $scope.init();
}])
    .controller("RoomOverviewCtrl",
    [
        '$rootScope', '$scope', '$q', '$filter', 'f_Interval', 'f_Info', '$translate', 'MenuEntries', 'parentMenuEntryId', '$state', 'conf_guidEmpty', 'viewMenuBarService', '__MenuEntry', 'xcenterUtils','xCenterConfig','f_Rooms','temperatureFunctionsService',
        function ($rootScope, $scope, $q, $filter, f_Interval, f_Info, $translate, MenuEntries, parentMenuEntryId, $state, conf_guidEmpty, viewMenuBarService, __MenuEntry, xcenterUtils,xCenterConfig,f_Rooms,temperatureFunctionsService) {


            var favoriteObject =
            {
                favoriteType: 'MenuEntry',
                favoriteObject: __MenuEntry.$buildRaw({
                    "MenuEntryId": '00000000-0000-0000-0000-000000000003',
                    "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                    "DeviceId": '00000000-0000-0000-0000-000000000000',
                    'CustomActionName': 'RoomManagement',
                    'DisplayName': 'Gebäude',
                    'ImageName': 'raum',
                    'CustomActionDatas': {
                        '$type': "System.Collections.Generic.List`1[[System.String, mscorlib]], mscorlib",
                        '$values': ['00000000-0000-0000-0000-000000000003']
                    },
                    $UI: {}
                })
            };
            viewMenuBarService.setFavorite(favoriteObject);



            if (xCenterConfig.interval.roomOverviewValues > 0) {
                f_Interval.unregisterIntervalByAppId( 'interval.roomOverview' );
                var i = {
                    'AppId': 'interval.roomOverview',
                    delay: xCenterConfig.interval.roomOverviewValues,
                    fn: function () {
                        var promise =  $q.defer();
                        __MenuEntry.$getRooms({
                            'WithDetails': true,
                            'RecursiveLevel': 4
                        })
                        .$then(function (data) {
                            for (var i = 0; i < this.length; i++) {
                                this[i].DeviceId = conf_guidEmpty;
                            }
                            const encodedArray = data.$encode();
                            let l = [];
                            for (let i = 0; i < encodedArray.length; i++) {
                                const elem = encodedArray[i];
                                delete elem.$type;
                                l.push(elem);
                            }
                            // var l = _.each(data.$encode(), function (a) {
                            //     delete a.$type;
                            //     return a;
                            // });
                            $scope.MenuEntries = angular.merge( $scope.MenuEntries, l );

                            for (let i = $scope.MenuEntries.length-1; i >= 0; i--) {
                                // Remove Favorites from list which where deleted in the meantime

                                var found = data.findIndex(a => {
                                    return a.MenuEntryId == $scope.MenuEntries[i].MenuEntryId
                                });
                                if (found == -1 ) {
                                    $scope.MenuEntries.splice(i, 1);
                                } else {
                                    // update Favorite
                                    $scope.MenuEntries[i].updateMenuEntryData( data[found] );

                                    data.splice(found, 1);
                                }
                            };
                            for (let i = 0; i < data.length; i++) {
                                const elem = data[i];
                                $scope.MenuEntries.push(elem);
                            }
                            // _.each(data, function (a) {
                            //     $scope.MenuEntries.push(a);
                            // });


                            $scope.MenuEntries.$dispatch('build-datapoints');
                            promise.resolve();
                        })
                        return promise.promise;

                    }
                };
                $scope.RoomsIntervall = f_Interval.registerInterval(i);
            }

            $scope.init = function () {
                $scope.rootScope = $rootScope;

                // f_Rooms.fetchRooms();
                $scope.addmode = $scope.editmode = false;
                $rootScope.addbutton = false;
                $scope.topMenuEntryId = parentMenuEntryId;
                // Init Buttons



                $scope.$UI = {};
                $scope.buttons = {
                    init: {

                        'sortButton': function () {
                            // $scope.sortmode = true;
                            $state.go('rooms.sort');

                        },
                        'editButton': function () {
                            // $scope.editMode = true;
                            $scope.$UI.editMode = true;
                            $scope.$UI.deleteList = [];
                            $scope.$UI.revertMenuEntries = angular.copy($scope.MenuEntries);
                            viewMenuBarService.setButtons($scope.buttons.editMode);
                            f_Interval.pauseIntervalByAppId( 'interval.roomOverview' );

                        }
                    },
                    editMode: {
                        'clearButton': function () {
                            // $scope.sortmode = true;

                            $scope.$emit('loading-start');
                            $scope.MenuEntries = __MenuEntry.$getRooms({
                                'WithDetails': true,
                                'RecursiveLevel': 4
                            }).$then(function () {
                                for (var i = 0; i < this.length; i++) {
                                    this[i].DeviceId = conf_guidEmpty;
                                    // this[i].DisplayName =this[i].Sort +this[i].DisplayName ;
                                }
                                $scope.$UI.editMode = false;
                                viewMenuBarService.setButtons($scope.buttons.init);
                                $scope.$emit('loading-stop');
                            });

                        },
                        'saveButton': function () {
                            $scope.$UI.editMode = false;


                            if ($scope.$UI.editItemBefore && $scope.$UI.editItem && xcenterUtils.wasEdited($scope.$UI.editItemBefore, $scope.$UI.editItem, ['DisplayName', 'ImageName', 'Sort', 'ParentMenuEntryId'])) {
                                $scope.$UI.editItem.$UI.changed = true;
                            }
                            $scope.$emit('loading-start');
                            if ($scope.$UI.editItem) {
                                $scope.$UI.editItem.$UI.editMode = false;
                            }

                            // First get alls Levels
                            var ChangedRooms = $filter('filter')($scope.MenuEntries, (e) => {
                                return (!e.$UI.new && e.$UI.changed);
                            });
                            var list = [];
                            var list2 = [];
                            // First save all Entrys, that are not new (temp MenuentryId)
                            for (var i = 0; i < ChangedRooms.length; i++) {
                                list.push(ChangedRooms[i].$save().$then(() => {}).$asPromise());
                            }
                            // Now Save all new Levels
                            const NewLevels = $filter('filter')($scope.MenuEntries, (e) => {
                                return (e.$UI.new && e.MenuEntryId.substr(0, 1) == 'T' && e.ParentMenuEntryId == $scope.topMenuEntryId);
                            });

                            for (let i = 0; i < NewLevels.length; i++) {
                                const ParentEntry = NewLevels[i];
                               
                                ParentEntry.$UI.oldTempMenuEntryId = ParentEntry.MenuEntryId;
                                delete ParentEntry.MenuEntryId;
                                ParentEntry.$UI.saveInProgress = true;
                                
                                list.push(
                                    ParentEntry.$save().$then((data) => {
                                        if (ParentEntry.$UI === undefined) {
                                            ParentEntry.$UI = {};
                                        }
                                        ParentEntry.$UI.saveInProgress = false;
                                        ParentEntry.MenuEntryId = data.MenuEntryId;
                                    }).$asPromise()
                                );
                            }
                            
                            
                            // Delete Entrys markForDelete
                            var DeleteListTemp = $filter('filter')($scope.MenuEntries,
                                function (e) {
                                    return e.$UI.markForDelete;
                                }
                            );
                            // Check for Children of DeleteList
                            for (var i = 0; i < DeleteListTemp.length; i++) {
                                list.push(DeleteListTemp[i].$destroy().$asPromise());

                                var Children = $filter('filter')($scope.MenuEntries,
                                    function (e) {
                                        return (e.ParentMenuEntryId == DeleteListTemp[i].MenuEntryId);
                                    }
                                );
                                for (var j = 0; j < Children.length; j++) {

                                    list.push(Children[j].$destroy().$asPromise());
                                }


                            }

                            var refresh = function () {

                                $scope.MenuEntries = __MenuEntry.$getRooms({
                                    'WithDetails': true,
                                    'RecursiveLevel': 4
                                }).$then(function () {
                                    for (var i = 0; i < this.length; i++) {
                                        this[i].DeviceId = conf_guidEmpty;
                                        // this[i].DisplayName =this[i].Sort +this[i].DisplayName ;
                                    }

                                    viewMenuBarService.setButtons( $scope.buttons.init );
                                    $scope.$emit('loading-stop');
                                    f_Interval.restartIntervalByAppId( 'interval.roomOverview' );


                                });

                            }

                            const prepareRestOfRoomsToBeSaved = () => {
                                const NewRooms = $filter('filter')($scope.MenuEntries, (e) => {
                                    return (e.$UI.new && e.MenuEntryId && e.MenuEntryId.substr(0, 1) == 'T' && e.ParentMenuEntryId != $scope.topMenuEntryId);
                                });
                                for(var j = 0; j < NewRooms.length; j++)
                                {
                                    if( !NewRooms[j].$UI.saveInProgress && NewRooms[j].ParentMenuEntryId.substr(0, 1) != 'T' ){
                                        delete NewRooms[j].MenuEntryId;
                                        list2.push( NewRooms[j].$save()
                                        .$then(function(data){
                                            this.MenuEntryId = data.MenuEntryId;
                                        })
                                        .$asPromise());
                                    }
                                }
                            }

                            if (list.length > 0) {
                                $q.all(list).then(() => {
                                    NewLevels.forEach(ParentEntry => {
                                        const Children = $filter('filter')($scope.MenuEntries, (e) => {
                                            return (e.$UI.new && e.ParentMenuEntryId == ParentEntry.$UI.oldTempMenuEntryId);
                                        });
                                        for (let j = 0; j < Children.length; j++) {
                                            const Child = Children[j];
                                            Child.$UI.saveInProgress = true;
                                            Child.ParentMenuEntryId = ParentEntry.MenuEntryId;
                                            delete Child.MenuEntryId;
                                            list2.push(
                                                Child.$save()
                                                .$then((data) => {
                                                    Child.$UI.saveInProgress = false;
                                                    Child.MenuEntryId = data.MenuEntryId;
                                                })
                                                .$asPromise()
                                            )
                                        }
                                    });

                                    prepareRestOfRoomsToBeSaved();
                                    if (list2.length > 0) {
                                        $q.all(list2).then(() => {
                                            refresh();
                                        });
                                    } else {
                                        refresh();
                                    }

                                });
                            } else {
                                prepareRestOfRoomsToBeSaved();
                                if (list2.length > 0) {
                                    $q.all(list2).then(() => {
                                        refresh();
                                    });
                                } else {
                                    refresh();
                                }
                            }

                        }

                    },
                    sortMode: {
                        'sortButtonGreen': true,
                        'sortButton': function () {
                            $scope.$UI.sortMode = false;
                            viewMenuBarService.setButtons($scope.buttons.init);
                        }

                    }
                }
                viewMenuBarService.setButtons($scope.buttons.init);
                $scope.MenuEntries = MenuEntries;
                // Refresh Vizualisation Datapoints;


            }
            $scope.addMenuEntry = function (ParentId) {
                if (!ParentId) {
                    ParentId = parentMenuEntryId;
                }
                var me = $filter('filter')($scope.MenuEntries, {ParentMenuEntryId: ParentId});

                /* Find max Sort room favorite. */
                let sort = undefined;
                for (let i = 0; i < me.length; i++) {
                    const elem = me[i];
                    if (sort === undefined || elem.Sort > sort.Sort) {
                        sort = elem;
                    }
                }

                if (sort === undefined || sort < 0) {
                    sort = {Sort: 0};
                }
                
                var o = {
                    "MenuEntryId": 'T-' + Math.round(Math.random() * 1000),
                    "DisplayName": $filter('translate')('MENUENTRY_NewRoom'),
                    "Sort": (sort.Sort + 1 ),
                    "MenuEntryType": 0,
                    "DeviceId": conf_guidEmpty,
                    "ParentMenuEntryId": ParentId,
                    'UserLevelRead': $rootScope.userlevel,
                    'UserLevelWrite': $rootScope.userlevel,
                    '$UI': {}

                };

                var obj = __MenuEntry.$buildRaw(o);

                $scope.MenuEntries.$add(obj);
                if ($scope.$UI.editItemBefore && $scope.$UI.editItem && xcenterUtils.wasEdited($scope.$UI.editItemBefore, $scope.$UI.editItem, ['DisplayName', 'ImageName', 'Sort', 'ParentMenuEntryId'])) {
                    $scope.$UI.editItem.$UI.changed = true;
                }
                if ($scope.$UI.editItem) {
                    $scope.$UI.editItem.$UI.editMode = false;
                }
                $scope.$UI.editItem = obj;
                obj.$UI.editMode = true;
                obj.$UI.changed = true;
                obj.$UI.new = true;
                //obj.$reveal();
            };


            $scope.MenuEntrySort =
            {
                levelThreshold: 900,
                dragThreshold: 910,
                raumRegelung: true,
                beforeDrag: function (e) {
                    if (!$scope.sortmode) {
                        return false;
                    }
                    return true;
                },
                dragMove: function (s, d, di) {
                    //console.log(s);
                    //console.log(d);
                    return true;
                },
                accept: function (source, dest, destIndex) {

                    if (source.$parent && source.$parent.$parent && source.$parent.$parent.$type == 'uiTree') {
                        //console.log( dest.$parent.$parent.$type);
                        if (dest.$parent && dest.$parent.$type == 'uiTree') {
                            return true;
                        }
                    } else if (dest.$parent && dest.$parent.$type == 'uiTreeNode') {
                        // Dragging a ChildItem
                        if (dest.$parent && dest.$parent.$type != 'uiTree') {
                            return true;
                        }

                    }


                    //return false;

                },
                dropped: function (e) {

                    var newPos = ( e.dest.index );
                    var SortPos;
                    var ParentMenuEntryId;

                    var item = e.source.nodesScope.$modelValue[e.source.index];

                    $rootScope.loading = true;
                    if (
                        e.dest.nodesScope.$modelValue
                        && e.dest.index == 0

                    ) {
                        // There is only the moved Item in List
                        // SortPos should be 0
                        SortPos = 0;
                        if (e.dest.nodesScope.$parent.$type == 'uiTree') {
                            // Sorting in Level: Geschoss
                            ParentMenuEntryId = '00000000-0000-0000-0000-000000000003';
                        } else if (e.dest.nodesScope.$parent.$type == 'uiTreeNode') {
                            ParentMenuEntryId = e.dest.nodesScope.$parent.$modelValue.Entry.MenuEntryId;

                        }


                    } else if (
                        e.dest.nodesScope.$modelValue
                        && e.dest.nodesScope.$modelValue.length > 1
                        && e.dest.index <= ( e.dest.nodesScope.$modelValue.length - 1
                        && e.dest.index > 0)
                    ) {
                        // Item is NOT the last Item
                        // Get Position by Prev Item
                        // Previous if case checks for first Element so we don't
                        // have to worry there is no prev Item.


                        var prevItem = e.dest.nodesScope.$modelValue[e.dest.index - 1];
                        var prevPos = prevItem.Entry.Sort;
                        SortPos = +1;
                        ParentMenuEntryId = e.dest.nodesScope.$modelValue[e.dest.index - 1].Entry.ParentMenuEntryId;


                    } else {
                        // Sorting To Last Item in List.
                        /*var prevItem = e.dest.nodesScope.$modelValue[ e.dest.index - 1 ];
                         var prevPos = e.dest.nodesScope.$modelValue[ e.dest.index - 1].Entry.Sort;
                         SortPos = prevPos + 1;
                         ParentMenuEntryId = e.dest.nodesScope.$modelValue[ e.dest.index - 1].Entry.ParentMenuEntryId;*/

                        //alert('Last IF Case dont know why');

                        var prevItem = e.dest.nodesScope.$modelValue[e.dest.index - 1];
                        var prevPos = prevItem.Entry.Sort;
                        SortPos = prevPos + 1;
                        ParentMenuEntryId = prevItem.Entry.ParentMenuEntryId;
                    }

                    var MoveRooms = [];

                    // Prev. API Version when all following Entrys should be saved

                    /*for(var i = e.dest.index; i < e.dest.nodesScope.$modelValue.length; i++)
                     {
                     e.dest.nodesScope.$modelValue[ i ].Entry.Sort = SortPos + (i - e.dest.index );
                     e.dest.nodesScope.$modelValue[ i ].Entry.ParentMenuEntryId = ParentMenuEntryId;

                     }*/
                    e.dest.nodesScope.$modelValue[e.dest.index].Entry.Sort = SortPos;
                    e.dest.nodesScope.$modelValue[e.dest.index].Entry.ParentMenuEntryId = ParentMenuEntryId;
                    MoveRooms.push(e.dest.nodesScope.$modelValue[e.dest.index].Entry);
                    var prom = f_Rooms.moveRooms(MoveRooms);
                    prom.then(function () {
                        $rootScope.loading = false;
                    })
                    //$scope.moveItemTo( e.dest.nodesScope.$modelValue[ e.dest.index ].Entry , SortPos,ParentMenuEntryId);
                    /*
                     if(e.dest.index == 0)
                     {
                     Sort = 0;
                     var pos =  event.dest.nodesScope.$modelValue[ Sort ].Entry.Sort - 1;
                     var parent = event.dest.sortableScope.modelValue[e].Entry.ParentMenuEntryId;
                     }else{
                     e = event.dest.index -1;
                     pos = event.dest.sortableScope.modelValue[ e ].Entry.Sort + 1;
                     parent = event.dest.sortableScope.modelValue[e].Entry.ParentMenuEntryId;
                     }*/
                    //console.log(parent+'--'+e);


                    // Generate Correct Positions
                    /*if(e.dest.nodesScope.$modelValue.length)
                     {
                     for(var i = 0; i <e.dest.nodesScope.$modelValue.length; i++)
                     {
                     e.dest.nodesScope.$modelValue[i].Entry.Sort = i ;
                     }
                     }*/
                    //moveItemTo

                    /*
                     console.log(item);
                     if(item && item.Entry)
                     {
                     //item.Entry.Sort = newPos;
                     //item.Entry.DisplayName = newPos +'|'+ item.Entry.DisplayName;

                     }else{
                     f_Info.add('ERROR','ERROR_ItemNotFound');
                     }
                     */
                    //$filter('orderBy')( e.dest.nodesScope.$modelValue ,'+Entry.Sort');

                }
            };

            $scope.selectCorrectRoomTemperature = function(actualTempArr) {
                return temperatureFunctionsService.selectCorrectTemperature(actualTempArr);
            };

            $scope.moveItemTo = function (item, index, ParentMenuEntryId) {
                //console.log(item);
                item.ParentMenuEntryId = ParentMenuEntryId;
                f_Rooms.moveRoom(item, index);
                //alert(item.FavoriteId + '   '+index);
            }


            $scope.addElement = function (list, parent) {
                var el = [];
                var sort = 0;

                var o = {
                    'editmode': true,
                    'add': 'MenuEntry',
                    'MenuEntryId': 'Pending',
                    "DisplayName": "",
                    "Sort": sort,
                    "MenuEntryType": 0,
                    'edited': true,
                    'UserLevelRead': $rootScope.userlevel,
                    'UserLevelWrite': $rootScope.userlevel
                };
                $translate('MENUENTRY_NewRoom')
                    .then(function (translatedValue) {
                        o.DisplayName = translatedValue;
                    });

                if (parent == 0) {
                    var parentId = '00000000-0000-0000-0000-000000000003';
                    var tempMenuEntryId = Date.now();
                    if (list.length > 0) {
                        sort = list[list.length - 1].Entry.Sort + 1;
                        o.Sort = sort;
                    }
                    o.ParentMenuEntryId = parentId;
                    o.TempMenuEntryId = tempMenuEntryId;
                    $translate('MENUENTRY_NewLevel')
                        .then(function (translatedValue) {
                            o.DisplayName = translatedValue;
                        });


                } else {

                    if (list.length > 0) {
                        sort = list[list.length - 1].Entry.Sort + 1;
                        o.Sort = sort;
                    }

                    if (parent.TempMenuEntryId != undefined) {
                        o.ParentMenuEntryId = parent.TempMenuEntryId;
                    } else {
                        o.ParentMenuEntryId = parent.MenuEntryId;
                    }

                }
                el['Entry'] = o;
                el['Children'] = [];
                el.editmode = true;
                el.edited = true;
                if ($scope.selectedItem != undefined) {
                    $scope.selectedItem.editmode = false;
                }

                $scope.selectedItem = el;
                list.push(el);
            }


// Update sort
            $scope.updateSort = function (list) {
                if (list == undefined) {
                    list = $scope.MenuEntries
                }
                for (var i = 0; i < list.length; i++) {
                    var o = list[i];
                    if (o.Entry.Sort != i) {
                        o.Entry.edited = true;
                    }
                    o.Entry.Sort = (i );


                    if (o.Children.length > 0) {
                        o.Children = $filter('orderBy')(o.Children, 'Entry.Sort');
                        for (var j = 0; j < o.Children.length; j++) {

                            var c = o.Children[j];
                            if (o.Entry.Sort != j) {
                                o.Entry.edited = true;
                            }
                            c.Entry.Sort = ( j );
                            c.Entry.edited = true;
                        }
                    }

                }
            }

// Save Items
            /*
             $scope.saveItems = function () {
             $rootScope.loading = true;
             if ($scope.selectedItem != undefined) {
             $scope.selectedItem.editmode = false;
             $scope.selectedItem = undefined;
             }
             var list = [];
             angular.forEach($scope.MenuEntries, function (item) {
             console.log('loop' + item.Entry.DisplayName);
             if (item.edited == true) {
             //var def = $q.defer();
             console.log('PushPromise for ' + item.Entry.DisplayName + '-' + item.Entry.edited);
             var deferred = $q.defer();


             item.Entry.loading = true;

             console.log('Promise for', item.Entry);
             item.Entry.loading = true;
             //return
             // Todo: Update to _MenuEntry and _MenuEntryRes
             var m = new MenuEntry($http);
             m.fillWithDataAndSave(item.Entry,
             function (data) {
             var newMenuEntryId = m.parseResponse(data);
             console.log('Written' + newMenuEntryId);
             item.Entry.MenuEntryId = newMenuEntryId;
             item.Entry.loading = false;
             f_Rooms.addRoom(item.Entry);

             if (item.Children && item.Children.length > 0) {
             angular.forEach(item.Children, function (child) {
             var el = child;
             el.Entry.ParentMenuEntryId = newMenuEntryId;
             el.Entry.loading = true;

             var men = new MenuEntry($http);
             men.fillWithDataAndSave(el.Entry, function (data) {
             var newChildMenuEntryId = m.parseResponse(data);
             console.log('WrittenChild' + newChildMenuEntryId);
             el.Entry.MenuEntryId = newChildMenuEntryId;
             f_Rooms.addRoom(el.Entry);
             el.Entry.loading = false;
             deferred.resolve();
             })
             })


             } else {
             // No Children. Return Promise with success
             deferred.resolve();
             }

             });


             list.push(deferred.promise);
             } else {
             // If Item has Children but Parent Item was not edited
             if (item.Children && item.Children.length > 0) {
             angular.forEach(item.Children, function (child) {
             var el = child;
             //el.Entry.ParentMenuEntryId = newMenuEntryId;
             if (child.edited == true) {
             console.log('Saving' + child.Entry.DisplayName);
             var deferred = $q.defer();
             el.Entry.loading = true;

             var men = new MenuEntry($http);
             men.fillWithDataAndSave(el.Entry, function (data) {
             var newChildMenuEntryId = men.parseResponse(data);
             console.log('WrittenChild' + newChildMenuEntryId);
             el.Entry.MenuEntryId = newChildMenuEntryId;
             f_Rooms.addRoom(el.Entry);
             el.Entry.loading = false;
             deferred.resolve();
             })
             list.push(deferred.promise);
             }
             })
             }

             }

             });


             angular.forEach($scope.deleteList, function (item) {
             var delDeffer = $q.defer();
             //$scope.deleteItem($scope.deleteList[i]);

             var me = new MenuEntry($http);
             me.fillWithDataAndDelete(item.Entry, function () {
             if (item.Children && item.Children.length > 0) {
             angular.forEach(item.Children, function (child) {

             var childMenuEntry = new MenuEntry($http);
             me.fillWithDataAndDelete(child.Entry, function (data) {
             child.Entry.loading = false;
             //$scope.findElementAndDelete(m.Children[i].Entry);
             delDeffer.resolve();

             });
             })
             } else {
             delDeffer.resolve();
             }
             })


             list.push(delDeffer.promise);
             })


             $q.all(list)
             .then(function () {
             $rootScope.loading = false;
             });

             //var r = f_Rooms.getRoomByMenuEntryId($scope.ParentMenuEntryId);


             /*
             for(var i = 0; i < $scope.MenuEntries.length; i++)
             {

             (function (i_copy){

             var o = $scope.MenuEntries[i];
             console.log(o.Entry.DisplayName);
             //o.Entry.Sort = i;
             //o.Entry.ParentMenuEntryId = $scope.ParentMenuEntryId ;
             //o.Entry.UserLevelRead = 0;
             //o.Entry.UserLevelWrite = 0;


             var m = new MenuEntry($http);
             if(o.Entry.edited == true)
             {
             o.Entry.loading = true;
             if(o.Entry.MenuEntryId == 'Pending')
             {

             m.fillWithDataAndSave(o.Entry,function(data){
             var d = m.parseResponse(data);
             o.Entry.MenuEntryId = d;
             o.Entry.loading = false;


             f_Rooms.addRoom( o.Entry );

             for(var pe = 0; pe < o.Children.length; pe++)
             {
             (function(pe,entry){
             var el = entry.Children[pe];
             el.Entry.ParentMenuEntryId = entry.Entry.MenuEntryId;
             el.Entry.loading = true;
             var men = new MenuEntry($http);
             men.fillWithDataAndSave(el.Entry,function(data){
             var d = m.parseResponse(data);
             el.Entry.MenuEntryId = d;
             f_Rooms.addRoom( o.Entry );
             el.Entry.loading = false;
             })
             })(pe,o);
             }




             });
             }else
             {
             m.fillWithDataAndSave(o.Entry,function()
             {
             o.Entry.loading = false;

             });
             }
             };

             if(o.Children.length > 0 && o.Entry.TempMenuEntryId == undefined)
             {
             for(var j = 0; j < o.Children.length ; j++)
             {
             var j_copy = j;
             (function (j_copy,i_copy){

             var c = $scope.MenuEntries[i_copy].Children[j_copy];

             if(c != undefined && c.Entry.edited == true)
             {
             c.Entry.Sort = j;
             c.Entry.ParentMenuEntryId = o.Entry.MenuEntryId;
             c.Entry.UserLevelRead = 0;
             c.Entry.UserLevelWrite = 0;
             var m = new MenuEntry($http);

             if(c.Entry.MenuEntryId == 'Pending')
             {
             m.fillWithDataAndSave(c.Entry,
             function(data){

             c.Entry.loading = false;
             var d = m.parseResponse(data);
             c.Entry.MenuEntryId = d;
             f_Rooms.addRoom( c.Entry );


             });
             }else
             {
             m.fillWithDataAndSave(c.Entry,function(){
             c.Entry.loading = false;
             });
             }
             }
             })(j,i);


             }
             $rootScope.loading = false;
             }

             // Walk through Delete list
             }(i))

             }

             r.Children = $scope.MenuEntries;
             */
//}

// Set edititem or navigate depending on Editmode
            /*
             $scope.clickItem = function(o)
             {
             if($scope.editmode == true)
             {
             $scope.setEditItem(o);
             }else{
             MasterService.loadresource(o.Entry);
             }
             }*/

// set edititem
            $scope.setEditItem = function (e) {
                e.edited = true;
                if ($scope.editmode == true) {
                    if ($scope.edititem) {
                        $scope.edititem.editmode = false;
                    }
                    if ($scope.edititem == e) {
                        e.editmode = (e.editmode) ? false : true;
                    } else {
                        e.editmode = true;
                        $scope.edititem = e;
                    }
                }
            }

// DEleteitem


// Mark item for delete
            $scope.markForDelete = function (m, index, list) {
                var e = list.splice(index, 1)[0];

                if ($scope.selectedItem.MenuEntryId == e.Entry.MenuEntryId) {
                    $scope.selectedItem = undefined;

                }
                if (e.Entry.MenuEntryId != 'Pending') {
                    $scope.deleteList.push(e);
                }
            }


            $scope.init();


// Navigate
            $scope.loadresource = function (obj) {
                var o = {
                    'deviceId': conf_guidEmpty,
                    'menuEntryId': obj.MenuEntryId
                };
                $state.go('device', o);
                //MasterService.loadresource(obj);

            };


        }
    ])
;
